import api from "../utils/axios";

export const fetchOrderCount = async () => {
	try {
		const response = await api.get("Order/order-counts-per-status");
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch order count.");
		}
	} catch (error) {
		console.error("An error occurred while fetching order count:", error);
	}
};

export const fetchFinances = async () => {
	try {
		const response = await api.get("Finance/dashboard-finances");
		if (response.status === 200) {
			const result = response.data[0];
			return result;
		}
	} catch (error) {
		console.log(error);
	}
};
